import React, { useState, useEffect } from 'react'
import { graphql, Link } from 'gatsby'
import { Helmet } from 'react-helmet'
import Fade from 'react-reveal/Fade'
import Layout from '../components/common/layout'
import BoxedLogo from '../images/home/Boxed-logo.svg'
import DailyBurnLogo from '../images/home/Daily-burn-logo.svg'
import HealthInstitute from '../images/home/Health-institute.svg'
import MoneyLion from '../images/home/money-lion.svg'
import ContactForm from '../components/common/contact-form'
import HomeStaticSection from '../images/home_static_section.svg'
import FlaskBrain from '../images/flask-brain.svg'
import LettersPeople from '../images/letters-people.svg'
import Squares from '../images/squares2.svg'
import { Carousel } from 'react-responsive-carousel'

const findGroup = (data, groupName) =>
    data.allGhostPost.group.find(findGroup =>
        findGroup.fieldValue === groupName ? true : false
    )

const Index = ({ data }) => {
    const header = findGroup(data, 'header').edges
    const footer = findGroup(data, 'footer').edges
    const carouselItems = findGroup(data, 'about-jump')
    const caseStudy = findGroup(data, 'case-study')
    let [animationTriggers, changeTrigger] = useState({
        firstSvg: false,
        secondSvg: false,
        thirdSvg: false,
        fourthSvg: false,
    })
    const [logo, changeLogo] = useState(MoneyLion)
    const logos = [BoxedLogo, DailyBurnLogo, HealthInstitute, MoneyLion]
    useEffect(() => {
        if (typeof window !== `undefined`) {
            window.addEventListener('scroll', () => scrollHandler())
            let logonumber = 0
            setInterval(() => {
                changeLogo(logos[logonumber])
                if (logonumber < 3) {
                    logonumber++
                } else {
                    logonumber = 0
                }
            }, 5000)
        }
    }, [])

    const scrollHandler = e => {
        let triggersCopy = Object.assign({}, animationTriggers)
        if (window.scrollY > 200) {
            triggersCopy.firstSvg = true
        }
        if (window.scrollY > 350) {
            triggersCopy.secondSvg = true
        }
        if (window.scrollY > 1500) {
            triggersCopy.thirdSvg = true
        }
        if (window.scrollY > 2850) {
            triggersCopy.fourthSvg = true
        }
        changeTrigger(triggersCopy)
    }
    return (
        <>
            <Layout header={header} footer={footer}>
                <Helmet>
                    <title>Jump</title>
                </Helmet>
                <section id="home-page" className="home">
                    {findGroup(data, 'MainBlock').edges.map(item => (
                        <div className="container">
                            <h1>{item.node.title}</h1>
                            <div
                                className="home__content"
                                dangerouslySetInnerHTML={{
                                    __html: item.node.html,
                                }}
                            />
                            <div className="home__img">
                                <div class="wrap">
                                    <img
                                        class="anim1"
                                        src={HomeStaticSection}
                                        alt=""
                                    />
                                    <img
                                        class="anim2"
                                        src={FlaskBrain}
                                        alt=""
                                    />
                                    <img
                                        class="anim3"
                                        src={LettersPeople}
                                        alt=""
                                    />
                                    <img class="anim4" src={Squares} alt="" />
                                </div>
                            </div>
                        </div>
                    ))}
                </section>
                <section className="home-page__content">
                    <div className="social-proof">
                        <h2>Great Brands Trust Us</h2>
                        <div className="trust-us__items-wrap">
                            {animationTriggers.firstSvg ? (
                                <svg
                                    className="trust-bg"
                                    id="svg1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="1532.974"
                                    height="272.037"
                                    viewBox="0 0 1532.974 272.037"
                                >
                                    <path
                                        id="Curve_line_pt_4"
                                        data-name="Curve line pt 1"
                                        stroke="#fff"
                                        d="M3681.079,11707.341c171.737-57.536,328.562,64.257,361.853,178.159,
                  83.815-75.039,217.527-63.64,281.755,0,58.184-58.57,217.819-75.229,
                  289.09-7.638,75.847-69.084,226.84-30.785,262.113,7.638,39.544-36.685,
                  166.944-70.683,215.079-107.6s-17.787-58.06-31.29-55.772-65.559,
                  21.188-29.759,89.045,181.135,150.444,181.135,150.444"
                                        fill="none"
                                        transform="translate(-3679.579 -11691.083)"
                                        stroke-linecap="round"
                                        stroke-width="3"
                                        stroke-dasharray="15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 2033"
                                        opacity="0.173"
                                    />
                                    <animate
                                        attributeName="stroke-dashoffset"
                                        begin=".1s"
                                        restart="never"
                                        values="2033; 0"
                                        repeatCount="1"
                                        dur="10s"
                                        fill="freeze"
                                        calcMode="linear"
                                    />
                                </svg>
                            ) : null}
                            <div className="trust-us__items container">
                                <Fade left>
                                    <div className="item-wrap">
                                        <div className="item">
                                            <span>$500M+</span>
                                            <p>Revenue</p>
                                            <p>Driven</p>
                                        </div>
                                    </div>
                                </Fade>
                                <Fade left>
                                    <div className="item-wrap">
                                        <div className="item">
                                            <span>20M+</span>
                                            <p>Users</p>
                                            <p>Acquired</p>
                                        </div>
                                    </div>
                                </Fade>
                                <Fade right>
                                    <div className="item-wrap">
                                        <div className="item">
                                            <span>3T+</span>
                                            <p>Data Points</p>
                                            <p>Measured</p>
                                        </div>
                                    </div>
                                </Fade>
                                <Fade right>
                                    <div className="item-wrap">
                                        <div className="item">
                                            <span>$1B+</span>
                                            <p>In Media Budget</p>
                                            <p>Managed</p>
                                        </div>
                                    </div>
                                </Fade>
                            </div>
                        </div>
                        <div className="logos__wrap">
                            {animationTriggers.secondSvg ? (
                                <svg
                                    className="logos-bg"
                                    id="svg2"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="102.739"
                                    height="407.708"
                                    viewBox="0 0 102.739 407.708"
                                >
                                    <path
                                        id="Curve_line_pt_3"
                                        data-name="Curve line pt 1"
                                        stroke="#fff"
                                        d="M5212.579,12214.865s-111.782,42.208-98.636,219.325,98.038,185.554,98.636,185.387"
                                        fill="none"
                                        transform="translate(-5111.34 -12213.365)"
                                        stroke-linecap="round"
                                        stroke-width="3"
                                        stroke-dasharray=" 15 17"
                                        opacity="0.173"
                                    />
                                    <animate
                                        id="p1"
                                        attributeName="stroke-dashoffset"
                                        values="480; 0"
                                        dur="2s"
                                        repeatCount="1"
                                        begin=".1s"
                                        fill="freeze"
                                        calcMode="linear"
                                    />
                                </svg>
                            ) : null}
                            <div className="logos container">
                                {typeof window !== `undefined` &&
                                window.innerWidth < 426 ? (
                                    <Fade spy={logo} duration={5000} forever>
                                        <img src={logo} alt="#" />
                                    </Fade>
                                ) : (
                                    <>
                                        <img src={BoxedLogo} alt="#" />
                                        <img src={DailyBurnLogo} alt="#" />
                                        <img src={HealthInstitute} alt="#" />
                                        <img src={MoneyLion} alt="#" />
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="reviews__wrap container">
                        <Carousel
                            className="reviews"
                            showThumbs={false}
                            showArrows={false}
                            showStatus={false}
                            autoPlay
                            infiniteLoop
                            emulateTouch
                            swipeable
                        >
                            {carouselItems.edges.map(carouselItem => (
                                <div
                                    key={carouselItem.node.ghostId}
                                    className="reviews__item"
                                >
                                    <div className="reviews__review">
                                        {carouselItem.node.excerpt}
                                    </div>
                                    <div className="reviews__reviewer">
                                        <img
                                            src={
                                                carouselItem.node.feature_image
                                            }
                                            alt="Reviewer"
                                        />
                                        <div>
                                            <span className="reviews__reviewer-name">
                                                {carouselItem.node.title}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </Carousel>

                        <Link to="/our-approach">
                            <button className="reviews__btn">
                                See What CMO’s Say About Jump
                            </button>
                        </Link>
                    </div>
                    <div className="working-process">
                        <div className="working-process__content">
                            <div className="content-items__top">
                                <h2>How We Maximize Your Revenue</h2>
                                {animationTriggers.thirdSvg ? (
                                    <svg
                                        className="working-top-bg"
                                        id="svg3"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="1331.078"
                                        height="846.957"
                                        viewBox="0 0 1331.078 846.957"
                                    >
                                        <path
                                            id="Curve_line_pt_1"
                                            data-name="Curve line pt 1"
                                            stroke="#fff"
                                            d="M5209.457,13107.011c-102.136,106.448-281.091,325.877-691.933,
                      313.474-229.248-6.921-286.94-81.23-404.452-61.856s-183.733,75.718-210.893,
                      141.558c-11.52,40.838-53.7,240.107,179.857,294.848,18.4,1.411,226.374,34.753,
                      413.992-60.506,44.754-20.964,94.084-34.067,173.183-39.518,42.3-2.915,92.821-11.207,
                      157.515,0,132.6,33.345,227.849,81.162,296.342,132.595,140.811,166.792,86.388,116.128,86.388,116.128"
                                            fill="none"
                                            transform="translate(-3890.223 -13105.512)"
                                            stroke-linecap="round"
                                            stroke-width="3"
                                            stroke-dasharray="15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 17, 15 3118"
                                            opacity="0.173"
                                        />
                                        <animate
                                            id="p1"
                                            attributeName="stroke-dashoffset"
                                            repeatCount="1"
                                            values="3118; 0"
                                            dur="10s"
                                            begin=".1s"
                                            fill="freeze"
                                            calcMode="linear"
                                        />
                                    </svg>
                                ) : null}
                                <div className="content-items container">
                                    <Fade right>
                                        {findGroup(
                                            data,
                                            'RevenueFirstThree'
                                        ).edges.map(item => (
                                            <div className="item">
                                                <img
                                                    src={
                                                        item.node.feature_image
                                                    }
                                                    alt="#"
                                                />
                                                <div>
                                                    <p>{item.node.title}</p>
                                                    <p>{item.node.excerpt}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </Fade>
                                </div>
                            </div>
                            <div className="content-items__bottom">
                                {animationTriggers.fourthSvg ? (
                                    <svg
                                        className="working-bottom-bg"
                                        id="svg4"
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="1294.144"
                                        height="508.063"
                                        viewBox="0 0 1294.144 508.063"
                                    >
                                        <g
                                            id="Group_636"
                                            data-name="Group 636"
                                            transform="translate(-246.028 -3807.427)"
                                        >
                                            <path
                                                id="Curve_line_pt_2"
                                                data-name="Curve line pt 2"
                                                stroke="#fff"
                                                d="M5248.672,14653.773c-211.137,79.013-577.2-81.859-830.633-154.875s-448,
                        45.043-459.493,221.5,76.9,250.629,160.522,253.963"
                                                fill="none"
                                                transform="translate(-3710 -10668)"
                                                stroke-linecap="round"
                                                stroke-width="3"
                                                stroke-dasharray="15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18,15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 18, 15 1782"
                                                opacity="0.22"
                                            />
                                            <path
                                                id="Path_289"
                                                data-name="Path 289"
                                                d="M4070.807,15018.523v21.736l18.766-10.552Z"
                                                transform="translate(-3656.075 -10724.771)"
                                                fill="#fff"
                                                opacity="0.191"
                                            />
                                        </g>
                                        <animate
                                            attributeName="stroke-dashoffset"
                                            values="1782; 0"
                                            dur="7s"
                                            begin=".1s"
                                            repeatCount="1"
                                            fill="freeze"
                                            calcMode="linear"
                                        />
                                    </svg>
                                ) : null}
                                <div className="content-items container">
                                    <Fade left>
                                        {findGroup(
                                            data,
                                            'RevenueSecondThree'
                                        ).edges.map(item => (
                                            <div className="item">
                                                <img
                                                    src={
                                                        item.node.feature_image
                                                    }
                                                    alt="#"
                                                />
                                                <div>
                                                    <p>{item.node.title}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </Fade>
                                </div>
                                <div>
                                    <Link to="/our-approach">
                                        <button className="working-process__btn">
                                            Learn How Our Approach Can 10x Your
                                            Revenue
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="case-study__wrap">
                    <div className="container">
                        <h2>Case study</h2>
                        <Carousel
                            className="case-study"
                            showThumbs={false}
                            showStatus={false}
                            autoPlay
                            infiniteLoop
                            emulateTouch
                            swipeable
                        >
                            {caseStudy.edges.map(item => (
                                <div className="case-study__item" key={item.id}>
                                    <div className="case-study__item-img">
                                        <div className="case-study__item-bg" />
                                        <img
                                            src={item.node.feature_image}
                                            alt="#"
                                        />
                                        <div className="case-study__logo" />
                                    </div>
                                    <div className="case-study__desc">
                                        <h3>{item.node.title}</h3>
                                        <p>{item.node.excerpt}</p>
                                        <button className="case-study__btn">
                                            Read Boxed’s Success Story
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </Carousel>
                    </div>
                </section>
                <section className="feedback">
                    <div className="container">
                        <h2>Hyperscale Your Revenue</h2>
                        <ContactForm firstName lastName company email />
                    </div>
                </section>
            </Layout>
        </>
    )
}
export default Index
// This page query loads all posts sorted descending by published date
// The `limit` and `skip` values are used for pagination
export const pageQuery = graphql`
    query GhostPostQuery {
        allGhostPost(
            filter: {
                tags: {
                    elemMatch: {
                        name: {
                            in: [
                                "Homepage"
                                "RevenueFirstThree"
                                "RevenueSecondThree"
                                "header"
                                "footer"
                            ]
                        }
                    }
                }
            }
        ) {
            group(field: tags___name) {
                fieldValue
                edges {
                    node {
                        id
                        html
                        slug
                        title
                        ghostId
                        tags {
                            name
                        }
                        children {
                            id
                        }
                        custom_excerpt
                        excerpt
                        feature_image
                    }
                }
            }
        }
    }
`
